"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleCommissionDataHelper = void 0;
class VehicleCommissionDataHelper {
    constructor(bids) {
        this.bids = bids;
        const currentYear = new Date().getFullYear();
        this.possibleYears = [`${currentYear}`, `${currentYear - 1}`];
    }
    getAllCommissionVehicleCombinations(vehicle) {
        if (vehicle.bid) {
            return [vehicle];
        }
        if (vehicle.commissionNumberYear) {
            return this.bids.map(bid => {
                return Object.assign(Object.assign({}, vehicle), { bid });
            });
        }
        else {
            return this.possibleYears.map(year => this.getAllCommissionVehicleCombinations(Object.assign(Object.assign({}, vehicle), { commissionNumberYear: year }))).flat();
        }
    }
}
exports.VehicleCommissionDataHelper = VehicleCommissionDataHelper;
//# sourceMappingURL=VehicleCommissionDataHelper.js.map